import { forwardRef } from 'react';
import { Button } from '@mui/material';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';

export interface SubscribeButtonProps {
    /** Whether the user is currently subscribed (drives icon, color, label). */
    subscribed: boolean;
    onClick: () => void;
    /** Label when not subscribed (default 'Subscribe'). */
    label?: string;
    /** Label when subscribed (default 'Subscribed'). */
    subscribedLabel?: string;
    disabled?: boolean;
}

/**
 * Shared subscription button used by both the event/market bell and the trader
 * bell, so they stay visually identical. Pure presentation — the owning bell
 * decides what the click does (open a popover, toggle, etc.).
 */
export const SubscribeButton = forwardRef<HTMLButtonElement, SubscribeButtonProps>(
    function SubscribeButton({ subscribed, onClick, label = 'Subscribe', subscribedLabel = 'Subscribed', disabled }, ref) {
        return (
            <Button
                ref={ref}
                onClick={onClick}
                disabled={disabled}
                size="small"
                variant="outlined"
                color={subscribed ? 'primary' : 'inherit'}
                startIcon={subscribed ? <NotificationsActiveIcon fontSize="small" /> : <NotificationsNoneIcon fontSize="small" />}
                sx={{ height: 24, px: 1.5, textTransform: 'uppercase', fontSize: '0.7rem' }}
            >
                {subscribed ? subscribedLabel : label}
            </Button>
        );
    }
);
